import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";

import InputBox from "./Components/InputBox";
import ColorSelector from "./Components/ColorSelector";
import useSaveNote from "./useSaveNote";
import MutationMessage from "../../Components/MutationMessage";
import importNote from "./importNote";
import CalendarButton from "./Components/CalendarButton";
import OptionButton from "./Components/OptionButton";

export default function NoteDialog({ open, handleClose, initNote }) {
  const { t } = useTranslation();
  const importedNote = importNote(initNote);
  // local state
  const [title, setTitle] = useState(importedNote.title);
  const [subtitle, setSubtitle] = useState(importedNote.subtitle);
  const [color, setColor] = useState(importedNote.color);
  const [time, setTime] = useState(importedNote.time);
  const note = { ...importedNote, title, subtitle, color, time };

  const handleTimestamp = (timestamp) => setTime(timestamp);

  // server state
  const saveNote = useSaveNote({ onSuccess: handleClose });
  const handleSave = () =>
    saveNote.mutate({ action: initNote ? "edit" : "add", payload: note });
  const handleDelete = () =>
    saveNote.mutate({ action: "delete", payload: note });

  return (
    <div>
      <MutationMessage mutation={saveNote} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="note-dialog"
        fullWidth={true}
        maxWidth="sm"
        sx={{ maxWidth: "sm", margin: "auto" }}
      >
        <Box padding={0}>
          <Box display="flex" alignItems="center">
            <Box width="100%">
              <InputBox
                textInput={title}
                setTextInput={setTitle}
                autoFocus={false}
                placeholder={t("common.placeholders.title")}
                customStyle={"title"}
              />
            </Box>
          </Box>
          <InputBox
            textInput={subtitle}
            setTextInput={setSubtitle}
            autoFocus={true}
            placeholder={t("create.noteHelp")}
            customStyle={"body"}
          />
        </Box>
        <DialogActions>
          <Box
            flexGrow={1}
            style={{ display: "flex", gap: 16, alignItems: "center" }}
          >
            <ColorSelector
              selectedColorValue={color}
              setSelectedColorValue={setColor}
            />

            <CalendarButton
              timestamp={time}
              handleTimestamp={handleTimestamp}
            />

            {initNote ? <OptionButton handleDelete={handleDelete} /> : null}
          </Box>

          <Box>
            <Button onClick={handleClose} color="inherit">
              {t("common.actions.close")}
            </Button>
          </Box>
          <Box>
            <Button
              onClick={handleSave}
              color="primary"
              disabled={saveNote.isLoading}
            >
              {t("common.buttons.save")}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
